import React from 'react';
import dayjs from 'dayjs';
import './assets/css/invoice.css'; // Import your CSS file

const Invoice = ({ data }) => {
    return (
        <>
            {data && (
                <>
                    <div className="wrapper-invoice">
                        {/* switch mode rtl by adding class rtl on invoice class */}
                        <div className="invoice">
                            <div className="invoice-information">
                                <p><b>เลขที่คำสั่งซื้อ #</b>: {data.orderNumber}</p>
                                <p><b>วันที่สั่ง </b>: {dayjs(data.createdAt).format('DD/MM/YYYY HH:mm:ss')}</p>
                            </div>
                            {/* logo brand invoice */}
                            <div className="invoice-logo-brand">
                                {/* <h2>Tampsh.</h2> */}
                                <img src="https://www.atom-soft.com/image-api/users/652b53ca93916.png" alt="" />
                            </div>
                            {/* invoice head */}
                            <div className="invoice-head">
                                <div className="head client-info">
                                    <p>{`ห้างหุ้นส่วนจำกัด เก็ท สปอร์ต ออแกไนซ์`}<br />
                                        {`เลขที่ 102 ม.11 ต.แสนสุข อ.วารินชำราบ`}<br />
                                        {`จ.อุบลราชธานี 34190`}
                                    </p>
                                </div>
                                <div className="head client-data">
                                    <h5>ออกให้กับ</h5>
                                    <p>{data.shippingAddress.name}<br />
                                        {`${data.shippingAddress.address} ต.${data.shippingAddress.subdistrict} อ.${data.shippingAddress.district}`}<br />
                                        {`จ.${data.shippingAddress.province} ${data.shippingAddress.zipcode}`}</p>
                                </div>
                            </div>
                            {/* invoice body*/}
                            <div className="invoice-body">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>ลำดับ</th>
                                            <th>สินค้า</th>
                                            <th>จำนวน</th>
                                            <th>ราคา/หน่วย</th>
                                            <th>จำนวนเงิน</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.items.map((item, index) => (
                                            <>
                                                <tr>
                                                    <td>{index + 1}</td>
                                                    <td>{item.product_name + '(' + item.variants[0].name + ')'}</td>
                                                    <td>{item.quantity}</td>
                                                    <td>{item.price}</td>
                                                    <td>{item.total}</td>
                                                </tr>
                                            </>
                                        ))
                                        }
                                    </tbody>
                                </table>
                                <div className="flex-table">
                                    <div className="flex-column"></div>
                                    <div className="flex-column">
                                        <table className="table-subtotal">
                                            <tbody>
                                                <tr>
                                                    <td>รวม</td>
                                                    <td>{data.totalAmount} บาท</td>
                                                </tr>
                                                <tr>
                                                    <td>ส่วนลด</td>
                                                    <td>{data.discount || 0} บาท</td>
                                                </tr>
                                                <tr>
                                                    <td>ค่าจัดส่ง</td>
                                                    <td>{data.deliveryfee || 0} บาท</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                {/* invoice total  */}
                                <div className="invoice-total-amount">
                                    <p>รวมทั้งสิ้น: {data.totalAmount + data.deliveryfee} บาท</p>
                                </div>
                            </div>
                            {/* invoice footer */}
                            <div className="invoice-footer">
                                <p>ขอบคุณที่ใช้บริการ</p>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>
    )
}

export default Invoice;
